<template>
    <span>
    <template v-if="prefix">{{prefix}}</template>
    <v-menu v-model="menuVisible" offset-y left :nudge-bottom="0">
        
        <template v-slot:activator="{ on }">
            <span class="label-menu" :class="{'label-menu-hoverable': !underline}" v-on="on">
                <span :class="{'dotted-underline': underline}">
                    {{buttonText}}
                </span>
                <v-icon v-if="!underline">mdi-menu-down</v-icon>
            </span>
        </template>

        <v-list>
            <v-list-item v-for="(menu, i) in menus" @click="menuClicked(menu)" :key="i">
                <v-list-item-title>{{menu.text || menu.value}}</v-list-item-title>
            </v-list-item>
        </v-list>            
    </v-menu>
    </span>
</template>

<script>

export default {
    data() {
        return {
            menuVisible: false,
        }
    },

    components: {
        
    },
    
    props: {
        prefix: String,
        underline: String,
        value: [String, Boolean, Number],
        disabled: Boolean,
        menus: Array,
        labelClass: {
            type: String,
            default: 'label-menu-default'
        },
    },

    computed: {
        buttonText () {
            let currentMenu = this.menus.find(o => o.value == this.value)
            if(currentMenu)
                return currentMenu.text || currentMenu.value
        },
        labelClassValue() {
            return this.labelClass + (this.disabled ? ' disabled' : '')
                
        },

    },

    methods: {
        menuClicked(menu) {
            let newVal = menu.value
            if(typeof newVal == 'undefined')
                newVal = menu.text 
            this.$emit('input', newVal)
            this.$emit('change', newVal)
        },
    },

    created() {
        if(!this.value)
            this.menuClicked(this.menus[0])
    }

}
</script>

<style scoped>
    .label-menu {
        margin:0px;padding:0px;border-radius:999px;cursor: pointer;display:inline-block;white-space: nowrap;
    }
    .label-menu.disabled {
        /* background-color:lightgray; */
        color: #999;
    }

    .label-menu-hoverable:hover {
        box-shadow: 0px 0px 0px .3em rgba(26, 136, 209, 0.2);
        background-color: rgba(26, 136, 209, 0.2)
    }

    .dotted-underline {
        text-decoration:underline;
        text-decoration-style: dotted;
        text-decoration-color: rgba(0,0,0,0.2)
    }
    .dotted-underline:hover {
        text-decoration-color: rgba(0,0,0,.4)
    }

    .dotted-underline.white {
        text-decoration:underline;
        text-decoration-style: dotted;
        text-decoration-color: rgba(255,255,255,0.4)
    }
    .white.dotted-underline:hover {
        text-decoration-color: rgba(255,255,255,1)
    }
   
</style>




// WEBPACK FOOTER //
// LabelMenu.vue?2a725a22